import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  connect = () => this.setupListeners(true);
  disconnect = () => this.setupListeners(false);

  setupListeners = (add = true) => {
    const method = add ? 'addEventListener' : 'removeEventListener';
    this.element[method]('mouseenter', this.show);
    this.element[method]('mouseleave', this.hide);
    this.element[method]('mousemove', this.zoom);
  }

  toggleDisplay = (show = true) => {
    this.element.style.backgroundImage = show ? `url(${this.element.dataset.imageUrl})` : null
    this.element.querySelector('img').style.visibility = show ? 'hidden' : 'visible'
  }

  show = ()=> this.toggleDisplay(true)
  hide = () => this.toggleDisplay(false)

  zoom = event => {
    const offsetX = event.offsetX || (event.pageX - this.element.offsetLeft)
    const offsetY = event.offsetY || (event.pageY - this.element.offsetTop)

    const x = (offsetX / this.element.offsetWidth) * 100
    const y = (offsetY / this.element.offsetHeight) * 100

    this.element.style.backgroundPosition = `${x}% ${y}%`
  }
}
